import { render, staticRenderFns } from "./plainTextProductForm.vue?vue&type=template&id=cc78dab4"
import script from "./plainTextProductForm.vue?vue&type=script&lang=js"
export * from "./plainTextProductForm.vue?vue&type=script&lang=js"
import style0 from "./plainTextProductForm.vue?vue&type=style&index=0&id=cc78dab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports